import { ResultsWithIcons } from '../SeparatedGrid/ResultsWithIcons';
import { EimearQuote } from './EimearQuote';

export const ProgrammeStatistics = (): JSX.Element => (
  <section className="bg-salmon md:px-[40px] lg:px-[60px]">
    <div className="relative flex flex-col md:container md:m-auto">
      <div className="mb-[40px] mt-[166px] lg:mb-[94px] lg:mt-[286px]">
        <ResultsWithIcons />
      </div>
      <div className="absolute top-[-125px] px-3 md:left-0 md:top-[-60px] md:max-w-[648px] md:px-0">
        <EimearQuote />
      </div>
    </div>
  </section>
);
